<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" persistent width="700" scrollable>
      <v-card>
        <v-toolbar dark dense>
          <v-toolbar-title class="headline">Edit store address</v-toolbar-title>
          <v-spacer />
          <v-icon @click="$emit('setDialog', false)">close</v-icon>
        </v-toolbar>
        <v-tabs v-model="tabs_address" grow light color="primary">
          <v-tabs-slider color="black"></v-tabs-slider>
          <v-tab v-for="item in lang_address" :key="item">{{ item }}</v-tab>
        </v-tabs>
        <v-card-text>
          <v-layout row wrap justify-center>
            <v-flex xs12 md12 class="pr-2">
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-tabs-items v-model="tabs_address">
                  <v-tab-item v-for="n in lang_address" :key="n">
                    <div style="padding-top:1px;">
                      <v-textarea
                        name="address"
                        label="Address"
                        v-model="edit_form['store_address_' + n]"
                        hint="Hint text"
                        rows="5"
                      ></v-textarea>
                    </div>
                  </v-tab-item>
                </v-tabs-items>
                <v-layout row v-if="loading == true">
                  <center>กำลังดึงข้อมูลจังหวัด ...</center>
                </v-layout>
                <v-layout row v-if="loading == false">
                  <v-flex xs6 class="mr-2">
                    <v-select
                      :rules="[rules.required]"
                      v-model="edit_form.store_province_id"
                      @change="getDistrict()"
                      :items="provinceItems"
                      item-text="province_name_th"
                      item-value="province_id"
                      label="Province"
                    ></v-select>
                  </v-flex>
                  <v-flex xs6 class="ml-2">
                    <v-select
                      :rules="[rules.required]"
                      v-model="edit_form.store_district_id"
                      @change="selectDistrict()"
                      :items="districtItems"
                      item-text="district_name_th"
                      item-value="district_id"
                      label="District"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout row v-if="loading == false">
                  <v-flex xs6 class="mr-2">
                    <v-select
                      :rules="[rules.required]"
                      v-model="edit_form.store_sub_district_id"
                      :items="subDistrictItems"
                      item-text="sub_district_name_th"
                      item-value="sub_district_id"
                      label="Sub district"
                    ></v-select>
                  </v-flex>
                  <v-flex xs6 class="ml-2">
                    <v-select
                      :rules="[rules.required]"
                      v-model="edit_form.store_zipcode_id"
                      :items="postcodeItems"
                      item-text="zipcode_code"
                      item-value="zipcode_id"
                      label="Post Code"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-textarea
                  v-model="edit_form.store_note"
                  name="note"
                  label="Place Note"
                  hint="Hint text"
                  rows="1"
                ></v-textarea>
                <v-layout row>
                  <v-flex xs6 class="mr-2">
                    <v-text-field
                      v-model="edit_form.store_lat"
                      :rules="[rules.required,rules.onlyDouble]"
                      label="latitude"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="ml-2">
                    <v-text-field
                      v-model="edit_form.store_long"
                      :rules="[rules.required,rules.onlyDouble]"
                      label="longitude"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="$emit('setDialog', false)">cancel</v-btn>
          <v-btn color="green" :disabled="isEditStoreList" flat @click="save()">save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: ["dialog", "edit_form", "loading"],
  data() {
    return {
      valid: true,
      tabs_address: null,
      lang_address: ["th", "en", "cn"],
      rules: {
        required: value => !!value || "Required.",
        onlyDouble: value => {
          const pattern = /^-?([0-9]?[0-9]?[0-9]?[0-9]|[0-9]0)\.{1}\d{1,100}$/;
          return pattern.test(value) || "Invalid";
        }
      }
    };
  },
  computed: {
    ...mapState({
      provinceItems: state => state.fetchProvinceBack.province_list,
      districtItems: state => state.fetchProvinceBack.district_list,
      subDistrictItems: state => state.fetchProvinceBack.sub_district_list,
      postcodeItems: state => state.fetchProvinceBack.zip_code_list
    }),
    ...mapGetters(["isEditStoreList"])
  },
  methods: {
    selectDistrict() {
      this.getSubDistrict();
      this.getPostCode();
    },
    getDistrict() {
      this.$store.dispatch(
        "fetchProvinceBack/getDistrictList",
        this.edit_form.store_province_id
      );
    },
    getSubDistrict() {
      this.$store.dispatch(
        "fetchProvinceBack/getSubDistrictList",
        this.edit_form.store_district_id
      );
    },
    getPostCode() {
      this.$store.dispatch(
        "fetchProvinceBack/getZipCodeList",
        this.edit_form.store_district_id
      );
    },
    cancel() {
      this.$emit("setDialog", false);
      this.$emit("cancelEditAddress");
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.$emit("setDialog", false);
        this.$emit("saveEditAddress");
        await this.$store.dispatch(
          "fetchStoreBack/editStoreAddress",
          this.edit_form
        );
        this.$emit("change");
      }
    }
  }
};
</script>